import Vue from 'vue';
import iView from 'view-design';
import i18n from './i18n';
import './assets/styles/theme/index.less'; // 引入自定义样式
import VCharts from 'v-charts';
import App from './app.vue';
import interceptor from './assets/js/interceptor';
import router from './router';
import store from './store';
import config from './config';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer'; // PC端详情页时  引用该组件 支持放大 旋转Vue.use(Viewer)
import * as globalComponents from '@/components/';

Object.keys(globalComponents).forEach(component => {
  const componentName = upperFirst(
    camelCase(component)
  );
  Vue.component(componentName,
    globalComponents[component]);
});

// Vue.use(iView); // 引用iView
Vue.use(iView, {
  i18n: function (path, options) {
    const value = i18n.t(path, options);
    if (value !== null && value !== undefined) return value;
    return '';
  }
}); // 引用iView

Vue.locale = () => {};

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    navbar: false,
    title: false,
    scalable: true,
    reset: false,
    loadingTips: '加载中...'
  }
});// 图片上传插件
Vue.use(VCharts); // 全局引用v-charts
Vue.prototype.$config = config; // 全局注册应用配置

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
});
